import { ControlledTable } from "Components";
import { columnType } from "DataTypes/Table";

export const TableCol: columnType[] = [
  ControlledTable.ColumnData.NameCol("50%"),
  ControlledTable.ColumnData.ProgramSFCol("50%"),
];